<template>
<div :style="style" class="nav-component-container">
  
    <div v-if="control.data.data.type==TYPE_SIMPLE_LIST">
        <div @click="handleBtnClick(item.target)" v-for="item in control.data.data.items" :key="item" class="simple-list-item">
            
            <CktextComponent :rawHtml="item.text"></CktextComponent>
            <span class="iconfont icon-xiayiyedanjiantou" style="color:lightgray"></span>

        </div>
    </div>
  
    <div v-if="control.data.data.type==TYPE_SIMPLE_LIST_BUTTON">
        <div v-for="item in control.data.data.items" :key="item" class="simple-list-item">
            <CktextComponent :rawHtml="item.text"></CktextComponent>
            <InlinebtnComponent :control="item.btn" :target="item.btn.data.target"></InlinebtnComponent>
        </div>
    </div>
  
    <div v-if="control.data.data.type==TYPE_SIMPLE_LIST_IMAGE">
        <div @click="handleBtnClick(item.target)" v-for="item in control.data.data.items" :key="item" class="simple-list-item image-list-item">
            <InlineImage :file="item.icon" :width="'46px'" :height="'46px'"></InlineImage>
            <CktextComponent :rawHtml="item.text" style="margin-left:1rem"></CktextComponent>
            <span class="iconfont icon-xiayiyedanjiantou" style="color:lightgray;flex-grow: 1;text-align: right;"></span>
        </div>
    </div>
  
    <div v-if="control.data.data.type==TYPE_SIMPLE_LIST_QnA">
        <div class="simple-list-item">
            <CktextComponent :rawHtml="control.data.data.title"></CktextComponent>
        </div>
        <div @click="handleBtnClick(item.target)" v-for="item in control.data.data.items" :key="item" class="simple-list-item">
            <CktextComponent :rawHtml="item.text"></CktextComponent>
        </div>
    </div>
  
    <div v-if="control.data.data.type==TYPE_LIST_IMAGE">
        <div @click="handleBtnClick(item.target)" v-for="item in control.data.data.items" :key="item" class="big-image-list-item">
            <CktextComponent :rawHtml="item.text" class="big-image-list-item-text-container"></CktextComponent>
            <div class="image-container">
                <InlineImage :file="item.icon" :width="'128px'" :height="'78px'"></InlineImage>
            </div>
        </div>
    </div>
  
    <div v-if="control.data.data.type==TYPE_2_COLUMN_GRID" class="grid-container" :style="divideColumn(control.data.data.type)">
        <div @click="handleBtnClick(item.target)" v-for="item in control.data.data.items" :key="item" class="row-item-container">
            <InlineImage :file="item.icon" :width="'46px'" :height="'46px'"></InlineImage>
            <div style="margin-left: 0.5rem;">
                <CktextComponent :rawHtml="item.text"></CktextComponent>
            </div>
        </div>
    </div>

    <div v-if="control.data.data.type==TYPE_3_COLUMN_GRID" class="grid-container" :style="divideColumn(control.data.data.type)">
        <div @click="handleBtnClick(item.target)" v-for="item in control.data.data.items" :key="item" class="item-container">
            <InlineImage :file="item.icon" :width="'46px'" :height="'46px'"></InlineImage>
            <div style="margin-top: 0.3rem;">
                <CktextComponent :rawHtml="item.text"></CktextComponent>
            </div>
        </div>
    </div>

    <div v-if="control.data.data.type==TYPE_4_COLUMN_GRID" class="grid-container" :style="divideColumn(control.data.data.type)">
        <div @click="handleBtnClick(item.target)" v-for="item in control.data.data.items" :key="item" class="item-container">
            <InlineImage :file="item.icon" :width="'46px'" :height="'46px'"></InlineImage>
            <div style="margin-top: 0.3rem;">
                <CktextComponent :rawHtml="item.text"></CktextComponent>
            </div>
        </div>
    </div>

    <div v-if="control.data.data.type==TYPE_3_COLUMN_GRID_SCATTERED" class="grid-container" :style="divideColumn(control.data.data.type)">
        <div @click="handleBtnClick(item.target)" v-for="item in control.data.data.items" :key="item" class="item-container">
            <InlineImage :file="item.icon" :width="'46px'" :height="'46px'"></InlineImage>
            <div style="margin-top: 0.5rem;">
                <CktextComponent :rawHtml="item.text"></CktextComponent>
            </div>
        </div>
    </div>

</div>
  
</template>

<script>

import InlineImage from '../Inlineimage.vue';
import InlinebtnComponent from './Inlinebtn.vue';
import CktextComponent from '../../CkText.vue';

export default {
  name: 'ListComponent',
  components: {
    InlineImage,
    InlinebtnComponent,
    CktextComponent
  },
  data(){
    return {
      style:'',
      TYPE_SIMPLE_LIST:1,
      TYPE_SIMPLE_LIST_IMAGE:2,
      TYPE_SIMPLE_LIST_BUTTON:3,
      TYPE_SIMPLE_LIST_QnA:4,
      TYPE_LIST_IMAGE:5,
      TYPE_2_COLUMN_GRID:6,
      TYPE_3_COLUMN_GRID:7,
      TYPE_4_COLUMN_GRID:8,
      TYPE_3_COLUMN_GRID_SCATTERED:9
    }
  },
  props: {
    control: null
  },
  methods:{
    divideColumn(type){

        switch(type) {

            case this.TYPE_2_COLUMN_GRID:
                return "grid-template-columns: 1fr 1fr";
            case this.TYPE_3_COLUMN_GRID:
                return "grid-template-columns: 1fr 1fr 1fr";
            case this.TYPE_3_COLUMN_GRID_SCATTERED:
                return "grid-template-columns: 1fr 1fr 1fr";
            case this.TYPE_4_COLUMN_GRID:
                return "grid-template-columns: 1fr 1fr 1fr 1fr";
            default:
                return "grid-template-columns: 1fr 1fr 1fr 1fr";

        }

    },
    handleBtnClick(target){

      if(target!==undefined)
        this.$common.gotoLink(this.$router,target,false);

    }  
  },
  updated(){

      

  },
  mounted(){


  },
  created(){
    
    this.style=this.$common.generateStyle(this.control.data.style);


  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.nav-component-container{
    text-align: center;
}
        .simple-list-item{
            display: flex;
            justify-content: space-between;
            font-size: 14px;
            padding: 21px 0;
            border-bottom: 1px solid rgba(151, 151, 151, 0.2);
            color: rgba(0, 0, 0, 0.87);
            align-items: center;
        }
        .big-image-list-item{
            display: flex;
            justify-content: space-between;
            font-size: 14px;
            padding: 21px 0;
            color: rgba(0, 0, 0, 0.87);
            align-items: center;
        }
        .big-image-list-item-text-container{
            min-height: 78px;
            margin-right: 16px;
            border-bottom: 1px solid rgba(120,130,140,0.13);
            color: rgba(0,0,0,0.87);
            flex-grow: 1;
            text-align: left;
            display: flex;
            align-items: center;
        }
        .image-container{
            border-radius: 4px;
            overflow: hidden;
        }        
        .image-list-item{
            padding: 10px 0 !important;
        }

    .grid-container{
        display: grid;
        row-gap: 20px;
    }
    
    .item-container{
        border:1px dashed rgba(120,130,140,0);
        justify-content: center;
        align-items: center;
        display: flex;
        flex-direction: column;
    }
    .row-item-container{
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;
    }    

</style>
